import { useCallback, useRef } from 'react'
import { observer } from 'mobx-react'
import { Box, Flex } from '@chakra-ui/react'
import Dropdown, { IDropdownItem } from '../../ui/Dropdown/Dropdown'
import rootStore from '../../../store/RootStore'
import ReactGA from 'react-ga4'
import { getMinutesSpentString } from '../../../utils/CommonHelper'

export const NavbarFilterGroup = observer(() => {
  const {
    reportStore: {
      filtersAvailableAtReportSectionId,
      setFilterOptionsSelected,
      filterOptionsSelected,
    },
  } = rootStore

  const time = useRef(new Date().getTime())

  const handleFilterChange = useCallback((filterName, option) => {
      setFilterOptionsSelected({ filterName, option })
      
      const deltaTime = new Date().getTime() - time.current
      const selectedFilters = [...filterOptionsSelected.values()]
        .map(filter => filter.label)
        .join(', ')

      ReactGA.event({
        category: 'filter',
        action: 'filter-change',
        label: `${selectedFilters}: ${getMinutesSpentString(deltaTime)}`,
      })

      time.current = new Date().getTime() // Reset the time
    }, [
      filterOptionsSelected,
      setFilterOptionsSelected,
    ]
  )

  if (filtersAvailableAtReportSectionId?.length === 0) {
    return <Box>No filters found</Box>
  }

  return (
    <Flex
      flexWrap="wrap"
      data-testid="filter-group">
      {filtersAvailableAtReportSectionId?.map((filter, index) => (
        <Dropdown
          key={index}
          onChange={option => handleFilterChange(filter.name, option)}
          items={getFilterOptions(filter)}
          selected={filterOptionsSelected.get(filter.name)}
        />
      ))}
    </Flex>
  )
})

const getFilterOptions  = filter => {
  const optionValues : IDropdownItem[] = filter.options.map(option => ({
    id: `${option.value}`,
    value: option.value,
    label: option.text,
  }))
  return optionValues
}
